import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumericDirective]'
})
export class NumericDirectiveDirective {

  constructor(private el: ElementRef<HTMLInputElement>) { }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    // Allow only numeric values
    const sanitizedValue = value.replace(/[^0-9]/g, '');

    // Check if the first character is '1', '2', '3', '4', or '5'
    let newValue = sanitizedValue;
    if (sanitizedValue.length > 0 && /^[0-5]/.test(sanitizedValue)) {
      // If it starts with '1-5', we want to replace it
      newValue = sanitizedValue.replace(/^[0-5]/, '');
    }

    // Update the value only if it differs from the current value to prevent infinite loop
    if (this.el.nativeElement.value !== newValue) {
      this.el.nativeElement.value = newValue;
      // Manually trigger the 'input' event if value was changed
      this.el.nativeElement.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}
